export class SeoTitle {
  readonly _prefix: string;
  readonly _main: string;
  readonly _postfix: string;
  constructor (
    titlePrefix: string | unknown,
    titleMain: string | unknown,
    titlePostfix: string | unknown,
  ) {
    this._prefix = typeof titlePrefix === 'string' ? titlePrefix : '';
    this._main = typeof titleMain === 'string' ? titleMain : '';
    this._postfix = typeof titlePostfix === 'string' ? titlePostfix : '';
  }
  changePrefix (newPrefix: string | unknown): SeoTitle {
    return new SeoTitle(
      newPrefix,
      this._main,
      this._postfix,
    );
  }
  changePostfix (newPostfix: string | unknown): SeoTitle {
    return new SeoTitle(
      this._prefix,
      this._main,
      newPostfix,
    );
  }
  joinedTitle (): string {
    return this._prefix + this._main + this._postfix;
  }
}
